import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://xaintro-backend.onrender.com';

const api = axios.create({
  baseURL: API_URL,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

const trendingProductService = {
  list: async (params) => {
    const res = await api.get('/trending-products', { params });
    return res.data;
  },
  get: async (id) => {
    const res = await api.get(`/trending-products/${id}`);
    return res.data;
  },
  create: async (payload) => {
    const res = await api.post('/trending-products', payload);
    return res.data;
  },
  update: async (id, payload) => {
    const res = await api.put(`/trending-products/${id}`, payload);
    return res.data;
  },
  remove: async (id) => {
    const res = await api.delete(`/trending-products/${id}`);
    return res.data;
  },
};

export default trendingProductService;


